//@getters
import { GetterTree } from "vuex";
// import { jobsProfileState } from "./state";

export const getters: GetterTree<any, any> = {};
